import { useMemo, useState } from 'react';
import { CDN_URL, supabase } from '@/services';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from './ui/button';
import { Spinner } from './ui/spinner';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

const ViewSignature = ({ appointmentId }: { appointmentId: string }) => {
  const [loadingImg, setLoadingImg] = useState<boolean>(true);

  const { data, isLoading } = useQuery({
    queryKey: ['images', appointmentId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('images')
        .select('image_url')
        .eq('appointment_id', appointmentId)
        .eq('type', 'signature')
        .single();

      if (error || !data) {
        console.error('Error fetching signature:', error?.message);
        return;
      }

      return data;
    },
  });
  const signatureUrl = useMemo(() => {
    if (data) {
      return `${CDN_URL}/object/public/${data.image_url}`;
    }
    return null;
  }, [data]);

  const { t } = useTranslation();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button disabled={isLoading}>{isLoading ? <Spinner /> : t('viewsignature')}</Button>
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('signature')}</DialogTitle>
        </DialogHeader>
        {signatureUrl ? (
          <div className="mt-4 relative  dark:bg-white/60">
            {loadingImg && (
              <div className="absolute  inset-0 flex items-center justify-center mb-10">
                <Spinner size={'medium'} />
              </div>
            )}
            <img
              onLoad={() => setLoadingImg(false)}
              onError={() => setLoadingImg(false)}
              src={signatureUrl}
              alt="Customer Signature"
              className={`border border-gray-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            />
          </div>
        ) : (
          <p>{t('notavailable')}</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewSignature;
